// extracted by mini-css-extract-plugin
export default {"container":"Video_container__cRYEB"};